import React__default, { useMemo, useEffect } from 'react';
import '../../constants/domains.js';
import '../../constants/globals.js';
import { SWAN_VERSION } from '../../constants/paths.js';
import '../../constants/tokens-color.js';
import { SwanPathTypeEnum } from '../../types/enums.js';
import { getSwanBaseUrl } from '../../utilities/base-url.utils.js';
import '../../utilities/manifest-icons.utils.js';
import '../../utilities/manifest-js.utils.js';
import { ExperimentsProvider } from '../experiments/experiments.context.js';
import { swanLoaderConfigProps, SwanContext } from './swan-provider.context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// TODO: Swan v2.0 Remove fontScale from Swan Provider
const propTypes = _objectSpreadProps(_objectSpread({}, swanLoaderConfigProps), {
  pathType: swanLoaderConfigProps.swanPathType
});
const SwanProvider = _ref => {
  let {
    swanBaseUrl,
    pathType,
    swanPathType,
    swanTenant,
    swanLocale,
    globalLinkComponent,
    experiments,
    children
  } = _ref;
  const value = useMemo(() => {
    return {
      globalLinkComponent,
      swanBaseUrl: swanBaseUrl || getSwanBaseUrl(swanTenant, swanLocale),
      swanPathType: swanPathType || pathType || SwanPathTypeEnum.hashed,
      swanTenant,
      swanLocale
    };
  }, [swanBaseUrl, swanPathType, pathType, globalLinkComponent, swanTenant, swanLocale]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.__swan = {
        version: SWAN_VERSION,
        swanBaseUrl: value.swanBaseUrl
      };
    }
  }, [value.swanBaseUrl]);
  return /*#__PURE__*/React__default.createElement(SwanContext.Provider, {
    value: value
  }, /*#__PURE__*/React__default.createElement(ExperimentsProvider, {
    experiments: experiments
  }, children));
};
SwanProvider.displayName = 'SwanProvider';
SwanProvider.propTypes = propTypes;
export { SwanProvider };